var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoadsmart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.827 5.284V.667h8.963c.3 0 .543.243.543.543v8.963h-4.617V5.555a.272.272 0 0 0-.272-.272H5.827ZM5.284.938v9.506c0 .15.121.272.272.272h9.506l-4.459 4.458a.544.544 0 0 1-.384.16H1.21a.543.543 0 0 1-.542-.543V5.78a.54.54 0 0 1 .159-.384L5.284.937Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoadsmart);
export default __webpack_public_path__ + "static/media/icon-loadsmart.04165f727b524f5996a89c3e21961f60.svg";
export { ForwardRef as ReactComponent };